import {
  Reducer,
  combineReducers,
  configureStore as configureReduxStore,
  createListenerMiddleware,
} from '@reduxjs/toolkit';
import { Router } from 'router5';
import { ImportedAppModule, unwrapModules } from './appModule';
import { routerMiddleware, routerReducer } from './router';

export type StoreOptions = {
  router: Router;
  modules?: ImportedAppModule[];
};

export const listener = createListenerMiddleware();

export const configureStore = async (options: StoreOptions) => {
  const { router } = options;
  const modules = await unwrapModules(options.modules ?? []);

  const reducers: Record<string, Reducer> = {};
  for (const module of modules) {
    if (!module.reducer || !module.reducerPath) {
      continue;
    }
    reducers[module.reducerPath] = module.reducer;
  }

  console.debug('configureStore/reducers', reducers);

  const store = configureReduxStore({
    reducer: combineReducers({
      ...reducers,
      router: routerReducer,
    }),
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware()
        .prepend(routerMiddleware(router))
        .prepend(listener.middleware);
    },
  });

  return store;
};
